import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierCT-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import CTPolicyChangesPage from './pages/CTPolicyChanges/CTPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierCTPolicyChangesPage: { component: 'PremierCTPolicyChangesPage' }
    },
    {
        PremierCTPolicyChangesPage: CTPolicyChangesPage
    }
);

export { default as PremierCTPolicyChangeWizard } from './PremierCTPolicyChangeWizard';
